import TextFieldBase from '../inputs/TextInput';
import createField from './createField';

const TextField = createField(TextFieldBase);

export default TextField;
